import React, { useEffect, useState } from 'react';
import { EventTypeInput } from '../../../types/ViewModel/EventTypeInput';
import { resolveHeading } from '../../../utils/event/headingOverrides';
import {
    RatingAndCommentWrapper,
    RatingInputOuterWrapper,
    StringInputWrapper,
    RatingInputWrapper,
    RatingHeadingWrapper,
    RatingWrapper,
} from './RatingInput.styles';
import StarRatings from 'react-star-ratings';
import eventInputUtils from '../../../utils/event/eventInputUtils';
import TextareaAutosize from 'react-textarea-autosize';

type Props = {
    onChange: (numberOfStars: number, comment: string | null, key: number, isEmpty: boolean, isValid: boolean) => void;
    evTypeInput: EventTypeInput;
    key: string;
};

const RatingInputComponent: React.FC<Props> = (props) => {
    const [numberOfSelectedStars, setNumberOfSelectedStars] = useState<number>(0);
    const [commentValue, setCommentValue] = useState<string | null>(null);
    const { isRatingInputValid, isRatingCommentInputValid, getMaxCharStr } = eventInputUtils();

    useEffect(() => {
        if (props.evTypeInput.eventTypeInputReg && props.evTypeInput.eventTypeInputReg.ratingReg) {
            setCommentValue(props.evTypeInput.eventTypeInputReg.ratingReg.ratingComment);
            setNumberOfSelectedStars(props.evTypeInput.eventTypeInputReg.ratingReg.ratingValue);
        }
    }, [props.evTypeInput]);

    const getNumberOfIcons = (): number => {
        if (props.evTypeInput.eventTypeInputRating && props.evTypeInput.eventTypeInputRating.numberOfIcons) {
            return props.evTypeInput.eventTypeInputRating.numberOfIcons;
        }
        // Return default
        return 5;
    };

    const getStarColor = (): string => {
        return '#00447e';
    };

    const inputHandlerRating = (newRating) => {
        setNumberOfSelectedStars(newRating);
        const valid = isRatingCommentInputValid(props.evTypeInput, newRating, commentValue) && isRatingInputValid(props.evTypeInput, newRating);
        props.onChange(newRating, commentValue, props.evTypeInput.eventTypeInputId, newRating === null, valid);
    };

    const inputHandlerString = (strEvent: string | null) => {
        setCommentValue(strEvent);
        const valid =
            isRatingCommentInputValid(props.evTypeInput, numberOfSelectedStars, strEvent) &&
            isRatingInputValid(props.evTypeInput, numberOfSelectedStars);
        props.onChange(numberOfSelectedStars, strEvent, props.evTypeInput.eventTypeInputId, !strEvent || strEvent.length === 0, valid);
    };

    return (
        <>
            <RatingWrapper>
                <RatingHeadingWrapper>{resolveHeading(props.evTypeInput)}:</RatingHeadingWrapper>
                <RatingAndCommentWrapper>
                    <RatingInputOuterWrapper>
                        <RatingInputWrapper isValid={isRatingInputValid(props.evTypeInput, numberOfSelectedStars)}>
                            <StarRatings
                                rating={numberOfSelectedStars}
                                starRatedColor={getStarColor()}
                                changeRating={inputHandlerRating}
                                key={props.evTypeInput.eventTypeInputId * 100}
                                numberOfStars={getNumberOfIcons()}
                                name="rating"
                                starDimension="20px"
                                starSpacing="3px"
                            />
                        </RatingInputWrapper>
                    </RatingInputOuterWrapper>
                    <StringInputWrapper isValid={isRatingCommentInputValid(props.evTypeInput, numberOfSelectedStars, commentValue)}>
                        <TextareaAutosize
                            className="input"
                            hidden={false}
                            key={props.evTypeInput.eventTypeInputId}
                            value={commentValue ?? undefined}
                            required={props.evTypeInput.mandatory}
                            onChange={(e) => inputHandlerString(e.target.value)}
                            maxLength={getMaxCharStr()}
                        />
                    </StringInputWrapper>
                </RatingAndCommentWrapper>
            </RatingWrapper>
        </>
    );
};

export default RatingInputComponent;
